import React from "react";
import { connect } from "react-redux";
import {
  DetailsList,
  Spinner,
  SpinnerSize,
  Dialog,
  DialogFooter,
  CheckboxVisibility,
  TextField,
  DatePicker,
  Dropdown,
  TagPicker,
  PrimaryButton,
  DetailsRow,
  DialogType,
  DefaultButton,
  Pivot,
  PivotItem,
  DetailsListLayoutMode,
} from "office-ui-fabric-react";
import { browserHistory } from "react-router";
import InfiniteScroll from "react-infinite-scroller";
import moment from "moment";
import axios from "axios";
import config from "../config";
import StatusBar from "./common/StatusBar";
import {
  LEAD_CATEGORY_LIST
} from "../constants/lists";
import { LEAD_CATEGORY } from "../constants/enums";
import ROUTE from "../constants/routes";
import { INFO_COLUMNS } from "../constants/tableConfig";
import AssignCategoryForm from "./common/AssignCategoryForm";

export class InfoList extends React.Component {
  constructor(props) {
    super(props);
    this.limit = 100;
    this.rowRefs = {};
    this.state = {
      editingCustomer: null,
      showDialogEdit: false,
      callingToCustomer: null,
      callingToPhone: "",
      callStatus: "",
      isLoading: false,
      isUpdating: false,
      hasMore: true,
      showCatDialog: false,
      showDialogDelete: false,
      columns: INFO_COLUMNS(),
      customers: [],
      filter: "all",
      staffs: [],
      searchText: "",
      total: 0,
      zipCodes: [],
      filterZipCodes: [],
      dateRange: "",
      filterYearStart: 0,
      filterYearEnd: 0,
      dateRangeOptions: (() => {
        var result = [];
        for (var i = 1900; i <= new Date().getFullYear(); i++) {
          result.push({
            text: i.toString(),
            key: i,
          });
        }
        return result;
      })(),
      filterLeadCategory: "",
      isLGPage:
        _.get(props, "location.pathname") === ROUTE.LEAD_GENERATOR_DASHBOARD,
      headerFilters: {},
      openHeaderFilters: true,
    };

    this.assignCategoryCallback = this.assignCategoryCallback.bind(this);
    this.refreshCustomerList = this.refreshCustomerList.bind(this);

  }

  componentDidMount() {
    this.fetch();
    axios
      .get(`${config.apiUrl}/zipcode/ofme`)
      .then(({ data }) => {
        this.setState({
          zipCodes: data,
        });
      })
      .catch((ex) => {
        console.error("[ERROR - /zipcode/ofme]:", ex);
      });

    axios
      .get(`${config.apiUrl}/user/me`)
      .then(({ data }) => {
        this.setState({
          userData: data,
        });
      })
      .catch((ex) => {
        console.error("[ERROR - /user/me]:", ex);
      });

    axios
      .get(`${config.apiUrl}/twilio/token`)
      .then(({ data }) => {
        this.timerTwilio = setInterval(() => {
          try {
            Twilio && Twilio.Device && this.setUpTwilio(data);
          } catch (ex) {
            console.error(ex);
            alert(
              "Have an error when connect to Twilio, refresh the website and try again"
            );
          }
          clearInterval(this.timerTwilio);
        }, 1000);
      })
      .catch((ex) => {
        console.error("[ERROR - /twilio/token]:", ex);
      });

    axios.get(`${config.apiUrl}/user/list`).then(({ data }) => {

      this.setState({
        staffs: data
          .filter((e) => e.accountType === "staff")
          .map((e) => ({ key: e.email, text: e.fname + " " + e.lname })),
        closers: data
          .filter((e) => e.accountType === "closer")
          .map((e) => ({
            key: e._id,
            text: `${e.fname} ${e.lname} | ${e.email}`,
          })),
      });
    });
  }

  componentWillUnmount() {
    Twilio.Device.instance.removeAllListeners();
    clearInterval(this.timerTwilio);
  }

  componentDidUpdate(prevProps) {
    if (
      !_.isEqual(
        _.get(prevProps, "location.pathname"),
        _.get(this.props, "location.pathname")
      ) ||
      !_.isEqual(
        _.get(prevProps, "location.search"),
        _.get(this.props, "location.search")
      )
    ) {
      this.setState(
        {
          customers: [],
          hasMore: true,
          isLGPage:
            _.get(this.props, "location.pathname") ===
            ROUTE.LEAD_GENERATOR_DASHBOARD,
        },
        () => {
          this.fetch(_.get(this.props, "searchBox"), 0);
        }
      );
    }
  }

  twilioReady() {
    this.updateCallStatus("Ready to call");
  }

  twilioConnect(connection) {
    this.callId = connection.parameters.CallSid;
    if ("phoneNumber" in connection.message) {
      if (this.state.callingToCustomer) {
        this.setState(({ callingToCustomer }) => ({
          callingToCustomer: {
            ...callingToCustomer,
            callingStatus: "open",
          },
        }));
      }
      this.updateCallStatus("In call");
    }
  }
  twilioError(error) {
    console.error(error);
    this.updateCallStatus("Error" + error.message);
    if (this.state.callingToCustomer) {
      this.setState(({ callingToCustomer }) => ({
        callingToCustomer: {
          ...callingToCustomer,
          callingStatus: "error",
        },
      }));
    }
    this.setState({
      callingToCustomer: null,
    });
  }
  twilioDisconnect() {
    clearInterval(this.timeoutCheckResponse);
    if (this.state.callingToCustomer) {
      this.setState(({ callingToCustomer }) => ({
        callingToCustomer: {
          ...callingToCustomer,
          callingStatus: "closed",
        },
      }));
    }
    if (this.callId && this.state.callingToCustomer) {
      setTimeout(() => {
        axios
          .get(`${config.apiUrl}/twilio/response/${this.callId}`)
          .then((v) => {
            this.callId = "";
            const data = v.data;
            if (
              !data ||
              [
                "failed",
                "canceled",
                "queued",
                "ringing",
                "initiated",
                "no-answer",
              ].includes(data.CallStatus)
            ) {
              this.setState(({ callingToCustomer }) => ({
                callingToCustomer: {
                  ...callingToCustomer,
                  processResults: "NA",
                },
              }));
              this.saveChange(this.state.callingToCustomer);
              this.updateCallStatus("No Answer");
              this.timeoutCheckResponse = setTimeout(() => {
                this.callId = "";
                this.setState(
                  {
                    callingToCustomer: null,
                  },
                  () => {
                    this.callButtonClick();
                  }
                );
              }, 1000);
              return;
            } else if (
              data &&
              ["completed", "in-progress"].includes(data.CallStatus)
            ) {
              this.setState(({ callingToCustomer }) => ({
                callingToCustomer: {
                  ...callingToCustomer,
                  callingStatus: "answer",
                },
              }));
              this.showProcess(this.state.callingToCustomer);
            }

            this.setState(
              {
                callingToCustomer: null,
              },
              () => {
                this.updateCallStatus("Ready to call");
              }
            );
          })
          .catch((ex) => {
            this.callId = "";
            console.error(ex);
            alert("Have an error when check response of dial");
          });
      }, 1000);
    } else if (this.callId && this.state.callingToPhone) {
      this.callId = "";
      this.setState(
        {
          callingToPhone: "",
        },
        () => {
          this.updateCallStatus("Ready to call");
        }
      );
    } else {
      this.callId = "";
      this.updateCallStatus("Ready to call");
      this.setState({
        callingToCustomer: null,
      });
    }
  }

  setUpTwilio(data) {
    if (Twilio.Device.instance) {
      this.updateCallStatus("Ready to call");
    } else {
      Twilio.Device.setup(data);
    }

    Twilio.Device.ready(() => this.twilioReady());
    Twilio.Device.error((error) => this.twilioError(error));
    Twilio.Device.connect((connection) => this.twilioConnect(connection));
    Twilio.Device.disconnect((connection) => this.twilioDisconnect(connection));
  }

  /* End a call */
  hangUp() {
    clearInterval(this.timeoutCheckResponse);
    if (this.callId) {
      // if (this.state.callingToCustomer) {
      //   this.setState(({ callingToCustomer }) => ({
      //     callingToCustomer: {
      //       ...callingToCustomer,
      //       callingStatus: "closed",
      //     },
      //   }));
      // }

      this.setState(
        {
          callingToCustomer: null,
          callingToPhone: "",
        },
        () => {
          Twilio.Device.disconnectAll();
          this.callId = "";
        }
      );
    }
  }

  voiceCall(customer) {
    clearInterval(this.timeoutCheckResponse);
    this.callId = "";
    customer.callingStatus = "calling";
    if (!this.rowRefs[customer._id]) {
      alert("Scroll down to new customer, which don't have status");
      return;
    }
    this.rowRefs[customer._id].scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
    this.setState(
      {
        callingToCustomer: customer,
      },
      () => {
        this.updateCallStatus("Calling");
        let phone = customer.phone;
        const phoneParam = new URLSearchParams(window.location.search).get("p");
        if (phoneParam) {
          phone = phoneParam.trim();
        }
        const params = {
          phoneNumber: phone,
          callFrom: _.get(this.state, "userData.phonecall"),
        };
        Twilio.Device.connect(params);
      }
    );
  }

  callButtonClick() {
    clearInterval(this.timeoutCheckResponse);
    if (this.state.callStatus === "") return;
    if (this.callId) {
      this.hangUp();
      axios
        .post(`${config.apiUrl}/auth/traking`, {
          type: "hang-up",
        })
        .catch((ex) => {
          console.error("[ERROR - /auth/traking]:", ex);
        });
    } else {
      axios
        .post(config.apiUrl + "/auth/traking", {
          type: "call",
        })
        .catch((ex) => {
          console.error("[ERROR - /auth/traking]:", ex);
        });
      const phoneNumber = this.refs.phoneNumber.value || "";
      if (phoneNumber.trim().length < 7) {
        const customers = this.state.customers;
        const foundCust = customers.find((e) => !e.processResults && !!e.phone);
        if (foundCust) {
          this.voiceCall(foundCust);
        }
      } else {
        this.setState(
          {
            callingToPhone: phoneNumber,
          },
          () => {
            this.updateCallStatus("Calling");

            var params = {
              phoneNumber: phoneNumber,
              callFrom: _.get(this.state, "userData.phonecall"),
            };
            Twilio.Device.connect(params);
          }
        );
      }
    }
  }

  updateCallStatus(s) {
    this.setState({
      callStatus: s,
    });
  }

  fetch(text, skip) {
    if (this.state.isLoading) {
      return;
    }

    this.setState({
      isLoading: true,
    });
    const commonParams = {
      tag: window.location.search.replace("?tag=", ""),
      ...(this.state.isLGPage
        ? {
          process:
            this.state.filterLeadCategory || LEAD_CATEGORY.NOT_INTERESTED,
        }
        : {
          process:
            this.state.filter === LEAD_CATEGORY.ALL ? "" : this.state.filter,
        }),
      zipCodes: this.state.filterZipCodes.map((e) => e.key),
      filterYearStart: this.state.filterYearStart,
      filterYearEnd: this.state.filterYearEnd,
      filterSearch:
        text == undefined || text == null
          ? this.props.searchBox.filter || ""
          : text.filter,
      q:
        text == undefined || text == null
          ? this.props.searchBox.text || ""
          : text.text,
      filterLastName: this.state.headerFilters.lastName,
      filterAddress: this.state.headerFilters.address,
      filterCity: this.state.headerFilters.city,
      filterPhone: this.state.headerFilters.phone,
      filterStaff: this.state.headerFilters.staff,
      ...(this.state.isLGPage
        ? {
          isLGPage: true,
        }
        : {
          isInfoPage: true,
        }),
    };
    axios
      .get(`${config.apiUrl}/customer/list`, {
        params: {
          ...commonParams,
          limit: this.limit,
          skip: skip != undefined ? skip : this.state.customers.length,
        },
      })
      .then(({ data }) => {
        const duplicatedCusts = _.intersectionBy(
          data,
          this.state.customers,
          "_id"
        );
        const newCustomers = data.filter(
          (e) => !duplicatedCusts.some((c) => c._id === e._id)
        );
        const customers =
          skip === 0 ? data : this.state.customers.concat(newCustomers);
        this.setState({
          customers,
          // customers,
          isLoading: false,
          hasMore: newCustomers.length >= this.limit,
        });
      })
      .catch(() => {
        this.setState({
          isLoading: false,
        });
      });

    axios
      .get(`${config.apiUrl}/customer/count`, {
        params: commonParams,
      })
      .then(({ data }) => {
        this.setState({
          total: data.total,
        });
      })
      .catch((ex) => {
        console.error("[ERROR - /customer/count]:", ex);
      });
  }

  saveChange(customer) {
    if ("WN" === customer.processResults) {
      this.deleteCustomer(customer);
    } else {
      customer.staffAssignedId = this.props.auth.user._id;
      customer.staffAssigned = this.props.auth.user;
      axios
        .post(`${config.apiUrl}/customer/update`, customer)
        .then(({ data }) => {
          this.setState({
            customers: this.state.customers.map((cust) => {
              if (cust._id === data._id) {
                return data;
              }
              return item;
            }),
          });
        })
        .catch((ex) => {
          console.error("[ERROR - /customer/update]:", ex);
          alert("Request updating customer failed!");
        });
    }
  }

  assignCategoryCallback(e) {
    this.setState(e);
  }

  refreshCustomerList(data) {

    this.setState({
      customers: this.state.customers.map((item) => {
        if (item._id === data._id) {
          return data;
        }
        return item;
      }).filter((item) => item.processResults !== "LE")
      ,
      showCatDialog: false
    })



  }


  showProcess(e) {
    this.rowSelected = e;
    this.selected = e.processResults;

    this.setState({
      showCatDialog: true
    });

  }

  closeDialog() {
    this.setState({
      showDialogEdit: false,
    });
    this.rowSelected = null;
  }

  showEdit(e) {
    this.setState({
      showDialogEdit: true,
      editingCustomer: {
        _id: e._id,
        firstName: e.firstName || "",
        lastName: e.lastName || "",
        middleName: e.middleName || "",
        address: e.address || "",
        birthDate: e.birthDate || "",
        city: e.city || "",
        emailAddress: e.emailAddress || "",
        phone: e.phone || "",
        state: e.state || "",
        zipCode: e.zipCode || "",
      },
    });
  }

  showDelete(e) {
    this.rowSelected = e;
    this.setState({
      showDialogDelete: true,
    });
  }

  deleteCustomer() {
    this.setState(
      {
        isUpdating: true,
      },
      () => {
        axios
          .post(`${config.apiUrl}/customer/remove`, {
            _id: this.rowSelected._id,
          })
          .then(({ data }) => {
            this.rowSelected = null;
            this.setState({
              showDialogDelete: false,
              showCatDialog: false,
              customers: this.state.customers.filter(
                (cust) => cust._id !== data._id
              ),
              isUpdating: false,
            });
          })
          .catch(() => {
            this.setState({
              showDialogDelete: false,
              showCatDialog: false,
              isUpdating: false,
            });
          });
      }
    );
  }

  print(e) {
    const url =
      config.apiUrl +
      "/customer/pdf/" +
      e._id +
      "?i=1&token=" +
      this.props.auth.user.token;
    const win = window.open(url);
    win.focus();
  }

  changeFilter(v) {
    this.setState(
      {
        filter: v.key,
        customers: [],
        hasMore: true,
      },
      () => {
        this.fetch(this.props.searchBox, 0);
      }
    );
  }

  changeFilterYear(start, end) {
    this.setState(
      {
        filterYearStart: start,
        filterYearEnd: end,
        customers: [],
        hasMore: true,
      },
      () => {
        this.fetch(this.props.searchBox, 0);
      }
    );
  }

  changeFilterByZipCodes(items) {
    this.setState(
      {
        customers: [],
        hasMore: true,
        filterZipCodes: [].concat(items),
      },
      () => {
        this.fetch(this.props.searchBox, 0);
      }
    );
  }


  valueChange(key, value) {
    this.setState((oldState) => ({
      editingCustomer: { ...oldState.editingCustomer, [key]: value },
    }));
  }

  saveUpdateInfo(data) {
    axios
      .post(`${config.apiUrl}/customer/update`, data)
      .then(({ data }) => {
        const isExisted = this.state.customers.some(
          (item) => item._id === data._id
        );
        this.setState({
          customers: isExisted
            ? this.state.customers.map((item) => {
              if (item._id === data._id) {
                return data;
              }
              return item;
            })
            : this.state.customers.concat(data),
          showDialogEdit: false,
        });
      })
      .catch((ex) => {
        console.error(ex);
      });
  }

  _onFilterChanged(filterText, list) {
    if (this.state.zipCodes === null) {
      return [];
    }

    const check = {};
    (list || []).forEach((e) => {
      check[e.key] = true;
    });

    const ftext = filterText.trim().toLowerCase();
    const result = [];
    for (let zipcode of this.state.zipCodes) {
      const tag = zipcode;
      if (tag.indexOf(ftext) === 0 && !check[tag]) {
        result.push(tag);
        if (result.length >= 20) break;
      }
    }

    return result.map((e) => ({
      key: e,
      name: e,
    }));
  }

  changeFilterCategory(value) {
    this.setState(
      {
        filterLeadCategory: value,
      },
      () => this.fetch(this.props.searchBox, 0)
    );
  }

  renderHeaderFilter({ fieldName, name = "" }) {
    const {
      staffs,
    } = this.state;

    let timeout;

    if (fieldName == "staff") {
      return (<Dropdown
        selectedKey={this.state.headerFilters[fieldName]}
        options={[{ key: "all", text: "All" }].concat(staffs)}
        onChanged={(value) => {
          this.setState(
            {
              headerFilters: {
                ...this.state.headerFilters,
                [fieldName]: value.key,
              },
            },

            () => {
              timeout = setTimeout(() => {
                this.fetch(this.props.searchBox, 0);
              }, 300);
            }
          );
        }}
      />)
    }

    return (
      <TextField
        name={fieldName}
        placeholder={`Find ${name.toLowerCase()}`}
        value={this.state.headerFilters[fieldName]}
        onChanged={(value) => {
          if (timeout) {
            clearTimeout(timeout);
          }
          this.setState(
            {
              headerFilters: {
                ...this.state.headerFilters,
                [fieldName]: value,
              },
            },
            () => {
              timeout = setTimeout(() => {
                this.fetch(this.props.searchBox, 0);
              }, 300);
            }
          );
        }}
      />
    );
  }

  render() {

    let columns = this.state.columns;
    const editingCustomer = this.state.editingCustomer;
    // render HTML
    columns = columns.map((col) => {
      if (col.key === "process") {
        col.onRender = (item) =>
          item.key !== "filterRow" && (
            <div>
              <button className="tbl-btn" onClick={() => this.showEdit(item)}>
                <i className="ms-Icon ms-Icon--Edit" aria-hidden="true"></i>
              </button>

              <button
                className="tbl-btn"
                onClick={() => this.showProcess(item)}
              >
                <i className="ms-Icon ms-Icon--AddGroup" aria-hidden="true"></i>
              </button>
              <button className="tbl-btn" onClick={() => this.print(item)}>
                <i className="ms-Icon ms-Icon--Print" aria-hidden="true"></i>
              </button>
              {this.state.userData && this.state.userData.phonecall && (
                <button
                  className="tbl-btn"
                  onClick={() => this.voiceCall(item)}
                >
                  <i className="ms-Icon ms-Icon--Phone" aria-hidden="true"></i>
                </button>
              )}

            </div>
          );
      } /*else if (col.key === "editData") {
        col.onRender = (item) =>
          item.key !== "filterRow" && (
            <div>
              <button className="tbl-btn" onClick={() => this.showEdit(item)}>
                <i className="ms-Icon ms-Icon--Edit" aria-hidden="true"></i>
              </button>
            </div>
          );
      }*/ else if (
        ["firstName", "lastName", "address", "staff", "birthDate", "phone", "city", "zipCode"].includes(col.key)
      ) {
        const oldRender = col.onRender;
        col.onRender = (item) => {
          if (item.key === "filterRow") {
            return this.renderHeaderFilter(col);
          }
          return oldRender ? oldRender(item) : item[col.fieldName];
        };
      }

      return col;
    });

    const {
      isLoading,
      hasMore,
      customers,
      total,
      filter,
      isLGPage,
      openHeaderFilters,
    } = this.state;

    return (
      <div style={{ margin: 10 }}>
        <div>
          <div
            style={{
              position: "fixed",
              top: 40,
              left: 0,
              right: 0,
              zIndex: 999,
              background: "white",
              padding: "10px 15px 15px 15px",
            }}
          >
            {isLGPage && (
              <div>
                <Pivot
                  aria-label="Lead Generator Type Tabs"
                  onLinkClick={(tab) => {
                    this.changeFilterCategory(tab.props.itemKey);
                  }}
                  selectedKey={this.state.filterLeadCategory}
                >
                  {LEAD_CATEGORY_LIST.filter((opt) =>
                    [
                      LEAD_CATEGORY.NOT_INTERESTED,
                      LEAD_CATEGORY.IN_PROCESS,
                    ].includes(opt.key)
                  ).map((opt) => (
                    <PivotItem
                      key={opt.key}
                      itemKey={opt.key}
                      linkText={opt.text}
                    />
                  ))}
                </Pivot>
              </div>
            )}
            <div style={{ marginTop: 20, display: "flex" }}>
              {!isLGPage && (
                <div style={{ width: 350 }} className="one-line-200">
                  <Dropdown
                    label="Filter by Process Result"
                    selectedKey={filter}
                    options={LEAD_CATEGORY_LIST}
                    onChanged={(v) => this.changeFilter(v)}
                  />
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  marginBottom: 10,
                  marginLeft: isLGPage ? 0 : 50,
                  alignItems: "center",
                }}
              >
                <div style={{ marginRight: 20 }}>Filter by ZipCodes</div>
                <TagPicker
                  ref="zipCodes"
                  onResolveSuggestions={this._onFilterChanged.bind(this)}
                  onChange={(items) => this.changeFilterByZipCodes(items)}
                  getTextFromItem={(item) => {
                    return item.name;
                  }}
                  onRenderSuggestionsItem={(item) => (
                    <span
                      style={{
                        color: item.needReAssign ? "blue" : "",
                        fontWeight: item.needReAssign ? "600" : "",
                      }}
                    >
                      {item.name}
                    </span>
                  )}
                  pickerSuggestionsProps={{
                    suggestionsHeaderText: "Zip Codes",
                    noResultsFoundText: "No Zip Code Found",
                  }}
                  defaultSelectedItems={this.filterZipCodes}
                />
              </div>
              <div
                style={{ width: 200, marginLeft: 50 }}
                className="one-line-100"
              >
                <Dropdown
                  label="Year of Birth"
                  selectedKey={this.state.filterYearStart}
                  options={[{ key: 0, text: "--" }].concat(
                    this.state.dateRangeOptions
                  )}
                  onChanged={(v) =>
                    this.changeFilterYear(
                      v.key <= this.state.filterYearEnd ||
                        v.key == 0 ||
                        this.state.filterYearEnd == 0
                        ? v.key
                        : this.state.filterYearStart,
                      this.state.filterYearEnd
                    )
                  }
                />
              </div>
              <div
                style={{ width: 150, marginLeft: 20 }}
                className="one-line-50"
              >
                <Dropdown
                  label="to"
                  style={{ width: 100 }}
                  selectedKey={this.state.filterYearEnd}
                  options={[{ key: 0, text: "--" }].concat(
                    this.state.dateRangeOptions
                  )}
                  onChanged={(v) =>
                    this.changeFilterYear(
                      this.state.filterYearStart,
                      v.key >= this.state.filterYearStart ||
                        v.key == 0 ||
                        this.state.filterYearStart == 0
                        ? v.key
                        : this.state.filterYearEnd
                    )
                  }
                />
              </div>
            </div>
            {this.state.userData && this.state.userData.phonecall && (
              <div style={{ display: "flex" }}>
                <div style={{ width: 300 }}>
                  <TextField
                    ref="phoneNumber"
                    className="one-line-100"
                    label="Call A Number"
                    placeholder="enter phone number"
                  ></TextField>
                </div>
                <div>
                  <PrimaryButton
                    onClick={() => this.callButtonClick()}
                    style={{ width: 150, height: 34 }}
                  >
                    {this.state.callingToCustomer ? "HANG UP" : "CALL"}
                  </PrimaryButton>
                  <span style={{ fontSize: 20, marginLeft: 20, color: "red" }}>
                    {this.state.callStatus}
                  </span>
                  {this.state.callingToCustomer && (
                    <span
                      style={{ fontSize: 20, marginLeft: 10, color: "red" }}
                    >
                      {">"} {this.state.callingToCustomer.phone} |{" "}
                      {this.state.callingToCustomer.firstName}{" "}
                      {this.state.callingToCustomer.lastName}
                    </span>
                  )}
                  {this.state.callingToPhone && (
                    <span
                      style={{ fontSize: 20, marginLeft: 10, color: "red" }}
                    >
                      {">"} {this.state.callingToPhone}
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div style={{ marginTop: 170 }}>
          <InfiniteScroll
            pageStart={0}
            loadMore={() => this.fetch()}
            useWindow={true}
            initialLoad={false}
            style={{ marginBottom: 30 }}
            hasMore={hasMore}
            loader={
              isLoading ? <Spinner key={1} size={SpinnerSize.large} /> : null
            }
          >
            <DetailsList
              items={[
                ...(openHeaderFilters ? [{ key: "filterRow" }] : []),
                ...customers,
              ]}
              columns={columns}
              layoutMode={DetailsListLayoutMode.justified}
              checkboxVisibility={CheckboxVisibility.hidden}
              style={{ fontSize: 20 }}
              setKey="_id"
              onColumnHeaderClick={() =>
                this.setState({
                  openHeaderFilters: !this.state.openHeaderFilters,
                })
              }
              onRenderRow={(props) => {

                let bg = "";
                if (props.item.callingStatus == "calling")
                  bg = "rgba(244, 67, 54, 0.5)";
                if (props.item.callingStatus == "open")
                  bg = "rgba(244, 67, 54, 0.5)";
                if (props.item.callingStatus == "cancel")
                  bg = "rgba(244, 67, 54, 0.5)";
                if (props.item.callingStatus == "answer")
                  bg = "rgba(76, 175, 80, 0.7)";
                if (props.item.key === "filterRow") {
                  bg = "rgba(240, 240, 240, 1)";
                }
                return (
                  <div
                    ref={(e) => (this.rowRefs[props.item._id] = e)}
                    style={{ background: bg }}
                  >
                    <DetailsRow {...props} />
                    {props.item.key !== "filterRow" && this.rowSelected && props.item._id === this.rowSelected._id && this.state.showCatDialog && (
                      <AssignCategoryForm rowSelected={this.rowSelected}
                        selected={this.selected}
                        assignCategoryCallback={this.assignCategoryCallback}
                        showDialog={this.state.showCatDialog}
                        refreshCustomerList={this.refreshCustomerList}
                        sequentialLeadNumber={this.state.sequentialLeadNumber}
                        isCloserPage={false}
                      />)
                    }
                  </div>
                );
              }}
            />
          </InfiniteScroll>
        </div>
        <StatusBar>
          <span>Total: {total}</span>
          {this.rowSelected && (
            <span>
              {" "}
              | Selected: #{customers.indexOf(this.rowSelected) + 1} -{" "}
              {`${this.rowSelected.firstName} ${this.rowSelected.lastName}`}{" "}
            </span>
          )}
        </StatusBar>
        <Dialog
          isOpen={this.state.showDialogDelete}
          title="Are you sure you want delete this customer?"
          isBlocking={false}
          closeButtonAriaLabel="Close"
        >
          <DialogFooter>
            {this.state.isUpdating ? (
              <Spinner key={1} size={SpinnerSize.large} />
            ) : (
              [
                <PrimaryButton key="del" onClick={() => this.deleteCustomer()}>
                  Delete
                </PrimaryButton>,
                <DefaultButton
                  key="cancel"
                  onClick={() => this.setState({ showDialogDelete: false })}
                >
                  Cancel
                </DefaultButton>,
              ]
            )}
          </DialogFooter>
        </Dialog>

        <Dialog
          isOpen={this.state.showDialogEdit}
          type={DialogType.normal}
          onDismiss={() => this.closeDialog()}
          title={`EDIT | ${editingCustomer && editingCustomer.firstName} ${editingCustomer && editingCustomer.lastName
            } | ${editingCustomer && editingCustomer.phone}`}
          isBlocking={true}
          containerClassName="relative-info"
        >
          {editingCustomer && (
            <div className="ms-Grid">
              <TextField
                className="one-line-150"
                label="First Name"
                value={editingCustomer.firstName}
                onChanged={(v) => this.valueChange("firstName", v)}
              />
              <TextField
                className="one-line-150"
                label="Middle Name"
                value={editingCustomer.middleName}
                onChanged={(v) => this.valueChange("middleName", v)}
              />
              <TextField
                className="one-line-150"
                label="Last Name"
                value={editingCustomer.lastName}
                onChanged={(v) => this.valueChange("lastName", v)}
              />
              <DatePicker
                className="one-line-150"
                label="Birth Date"
                value={
                  editingCustomer.birthDate
                    ? new Date(editingCustomer.birthDate)
                    : undefined
                }
                onSelectDate={(v) => this.valueChange("birthDate", v)}
                formatDate={(date) => moment(date).format("MMM DD YYYY")}
                allowTextInput
              />
              <TextField
                className="one-line-150"
                label="Phone Number"
                value={editingCustomer.phone}
                onChanged={(v) => this.valueChange("phone", v)}
              />
              <TextField
                className="one-line-150"
                label="Email Address"
                value={editingCustomer.emailAddress}
                onChanged={(v) => this.valueChange("emailAddress", v)}
              />
              <TextField
                className="one-line-150"
                label="Address"
                value={editingCustomer.address}
                onChanged={(v) => this.valueChange("address", v)}
              />
              <TextField
                className="one-line-150"
                label="City"
                value={editingCustomer.city}
                onChanged={(v) => this.valueChange("city", v)}
              />
              <TextField
                className="one-line-150"
                label="State"
                value={editingCustomer.state}
                onChanged={(v) => this.valueChange("state", v)}
              />
              <TextField
                className="one-line-150"
                label="Zip code"
                value={editingCustomer.zipCode}
                onChanged={(v) => this.valueChange("zipCode", v)}
              />
            </div>
          )}

          <DialogFooter>
            <PrimaryButton onClick={() => this.saveUpdateInfo(editingCustomer)}>
              Save
            </PrimaryButton>
            <DefaultButton onClick={() => this.closeDialog()}>
              Cancel
            </DefaultButton>
          </DialogFooter>
        </Dialog>
      </div>
    );
  }
}

export default connect((state) => ({
  auth: state.auth,
  searchBox: state.app.searchBox || { filter: "", text: "" },
}))(InfoList);



// WEBPACK FOOTER //
// ./client/components/InfoList.js